import Http from '../api/http';

export default class AiAudit extends Http {
  constructor() {
    super();
  }
  /**
   * 获取批注
   * @params { reportExperienceInfoId }
   * @returns
   */
  aiAudit_aiAuditReportInfo() {
    return super.post('aiAudit/aiAuditReportInfo', ...arguments);
  }
  /**
   * 获取单个考核点批注
   * @returns 批注
   */
  aiAudit_aiAuditReportInfoForC() {
    return super.post('aiAudit/aiAuditReportInfoForC', ...arguments);
  }

  /**
   * 错别字
   * @param {string} id -  string
   */
  aiAnalysis_analyzeErrorWords() {
    return super.post('aiAnalysis/analyzeErrorWords', ...arguments);
  }

  /**
   * 检测AI内容
   * @returns
   */
  aiAnalysis_checkWhetherAiContent() {
    return super.post('aiAnalysis/checkWhetherAiContent', ...arguments);
  }

  /**
   * 获取AI智能审核结果
   * @returns
   */
  aiAuditReport_getAuditResult() {
    return super.post('aiAuditReport/getAuditResult', ...arguments);
  }

  /**
   * AI审核报告头（重新审核）
   * @returns
   */
  aiAnalysis_aiAuditReportAttribute() {
    return super.post('aiAnalysis/aiAuditReportAttribute', ...arguments);
  }
}
